import { useEffect, useMemo, useState } from 'react';
import isEqual from 'lodash/isEqual';
import { SelectOption } from 'modules/queryBuilder/contexts';

export type CombinedOptionsType = Record<number, SelectOption<string>[]>;

export type UseCombineFetchedOptionsProps = {
  options: SelectOption<string>[];
  page: number;
  isLoading: boolean;
};

export const useCombineFetchedOptions = ({
  options = [],
  page,
  isLoading,
}: UseCombineFetchedOptionsProps) => {
  const [storedOptions, setStoredOptions] = useState<CombinedOptionsType>({});

  const resetCombinedOptions = () => {
    setStoredOptions({});
  };

  useEffect(() => {
    if (
      !isLoading &&
      (!(page in storedOptions) || !isEqual(storedOptions[page], options)) &&
      !!options.length
    ) {
      const newOptions = {
        ...storedOptions,
        [page]: options,
      } as CombinedOptionsType;
      setStoredOptions(newOptions);
    }
  }, [options, isLoading, storedOptions, page]);

  const combinedOptions = useMemo(() => Object.values(storedOptions).flat(), [storedOptions]);

  return {
    combinedOptions,
    resetCombinedOptions,
  };
};
